import { DatetimeBase } from './datetime-base';

export class TextInputBase extends DatetimeBase<string> {
    override controlType = 'text';
    type: string;

    constructor(options: {} = {} ) {
        super(options);
        this.type = options['type'] || '';
    }
}
